import { useMemo } from "react";
import { useProfile } from "../DataHooks/useProfile";

export const localeOptions = [
  { code: "en-US", name: "English (US)", format: "MM/DD/YYYY" },
  { code: "en-GB", name: "English (UK)", format: "DD/MM/YYYY" },
];

export const getProfileParamsLocale = (profile) => {
  if (profile && profile.params && profile.params.locale) {
    return profile.params.locale;
  } else if (window.navigator && window.navigator.language) {
    return window.navigator.language;
  } else {
    return "en-US"; //last default
  }
};

export const useProfileLocale = () => {
  const { profile } = useProfile();
  return useMemo(() => getProfileParamsLocale(profile), [profile]);
};
